import Header from '../components/Header';
import Footer from '../components/Footer';
import React, { useEffect, useState } from 'react';
import { Container, Typography, TextField, Button, List, ListItem, ListItemText, IconButton, Box, Alert, Tooltip, Divider, Card, CardContent } from '@mui/material';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';
import SafeText from '../components/SafeText';
import api from '../axios';
import ContextNavBar from '../components/ContextNavBar';

// Função utilitária para garantir que nunca será renderizado um objeto React, array ou valor inesperado como filho
function safeToString(val) {
  if (val == null) return '-';
  if (typeof val === 'string' || typeof val === 'number') return val;
  if (Array.isArray(val)) return '[array]';
  if (typeof val === 'object' && val.$$typeof) return '[elemento React]';
  if (typeof val === 'object' && val.nome) return val.nome;
  if (typeof val === 'object' && val.data) return val.data;
  try {
    return JSON.stringify(val);
  } catch {
    return '[objeto]';
  }
}

function Periodos() {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [periodos, setPeriodos] = useState([]);
  const [mes, setMes] = useState('');
  const [ano, setAno] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [editId, setEditId] = useState(null);
  const [editMes, setEditMes] = useState('');
  const [editAno, setEditAno] = useState('');

  // Função para buscar os períodos
  const fetchPeriodos = async () => {
    try {
      const res = await api.get('/periodos_crud/');
      setPeriodos(res.data);
    } catch {
      setErro('Erro ao buscar períodos');
    }
  };

  useEffect(() => {
    fetchPeriodos();
  }, []);

  // Função para adicionar um período
  const handleAdd = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    if (!mes || !ano) {
      setErro('Preencha mês e ano');
      return;
    }
    try {
      await api.post(`/periodos_crud/?mes=${mes}&ano=${ano}`);
      setMes(''); setAno('');
      setSucesso('Período cadastrado!');
      fetchPeriodos();
    } catch {
      setErro('Erro de conexão');
    }
  };

  // Função para deletar um período
  const handleDelete = async (id) => {
    try {
      await api.delete(`/periodos_crud/${id}`);
      setSucesso('Período excluído!');
      fetchPeriodos();
    } catch {
      setErro('Erro de conexão');
    }
  };


  // Função para iniciar edição
  const handleEdit = (id) => {
  const periodo = periodos.find(p => p.id === id);
  setEditId(id);
  setEditMes(periodo.mes || '');
  setEditAno(periodo.ano || '');
  setErro('');
  setSucesso('');
  setOpenEditModal(true);
  };

  // Função para cancelar edição
  const handleCancelEdit = () => {
  setEditId(null);
  setEditMes('');
  setEditAno('');
  setOpenEditModal(false);
  };

  // Função para salvar edição
  const handleSaveEdit = async (id) => {
  setErro(''); setSucesso('');
    if (!editMes || !editAno) {
      setErro('Preencha mês e ano');
      return;
    }
    try {
      await api.put(`/periodos_crud/${id}`, { mes: editMes, ano: editAno });
  setSucesso('Período atualizado!');
  setEditId(null);
  setOpenEditModal(false);
  fetchPeriodos();
    } catch {
      setErro('Erro de conexão');
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <Button component={RouterLink} to="/area-startfy" variant="outlined" startIcon={<ArrowBackIcon />} sx={{ mb: 3 }}>
        Voltar
      </Button>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: { xs: 1, md: 2 } }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#1C1C1E', fontSize: { xs: '1.3rem', md: '2rem' } }}>
          Períodos
        </Typography>
        <Button variant="contained" sx={{ bgcolor: '#00F1A7', color: '#1C1C1E', fontWeight: 700, '&:hover': { bgcolor: '#00C48C' } }} onClick={() => setOpenModal(true)} startIcon={<AddIcon />}>
          Novo
        </Button>
      </Box>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '90%', maxWidth: 520 }}>
          <Card>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>Cadastrar Período</Typography>
                <IconButton onClick={() => setOpenModal(false)}><CloseIcon /></IconButton>
              </Box>
              <Box component="form" onSubmit={(e) => { handleAdd(e); if (!erro) setOpenModal(false); }} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField label="Mês" value={mes} onChange={e => setMes(e.target.value)} fullWidth size="small" placeholder="Ex: JANEIRO" />
                <TextField label="Ano" value={ano} onChange={e => setAno(e.target.value)} fullWidth size="small" placeholder="Ex: 2026" />
                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                  <Button type="submit" variant="contained" sx={{ flex: 1, bgcolor: '#00F1A7', color: '#1C1C1E', fontWeight: 700, '&:hover': { bgcolor: '#00C48C' } }} startIcon={<SaveIcon />}>Cadastrar</Button>
                  <Button variant="outlined" color="inherit" onClick={() => setOpenModal(false)} sx={{ flex: 1 }} startIcon={<CloseIcon />}>Cancelar</Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Modal>
      {erro && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {typeof erro === 'string' ? erro : JSON.stringify(erro)}
        </Alert>
      )}
      {sucesso && (
        <Alert severity="success" sx={{ mb: 1 }}>
          {typeof sucesso === 'string' ? sucesso : JSON.stringify(sucesso)}
        </Alert>
      )}
      <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
      <List sx={{ width: '100%' }}>
        {periodos.map((periodo, idx) => (
          <React.Fragment key={periodo.id}>
            <ListItem
              secondaryAction={
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Tooltip title="Editar Período">
                    <IconButton edge="end" onClick={() => handleEdit(periodo.id)} color="info">
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Excluir Período">
                    <IconButton edge="end" onClick={() => handleDelete(periodo.id)} color="error">
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
            >
              <ListItemText
                primary={`${safeToString(periodo.mes)} / ${safeToString(periodo.ano)}`}
                primaryTypographyProps={{ sx: { fontWeight: 600 } }}
              />
            </ListItem>
            {idx < periodos.length - 1 && <Divider component="li" />}
          </React.Fragment>
        ))}
      </List>
      </Card>
      <Modal open={openEditModal} onClose={handleCancelEdit}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '90%', maxWidth: 520 }}>
          <Card>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>Editar Período</Typography>
                <IconButton onClick={handleCancelEdit}><CloseIcon /></IconButton>
              </Box>
              <Box component="form" onSubmit={(e) => { e.preventDefault(); handleSaveEdit(editId); }} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField label="Mês" value={editMes} onChange={e => setEditMes(e.target.value)} fullWidth size="small" />
                <TextField label="Ano" value={editAno} onChange={e => setEditAno(e.target.value)} fullWidth size="small" />
                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                  <Button type="submit" variant="contained" sx={{ flex: 1, bgcolor: '#00F1A7', color: '#1C1C1E', fontWeight: 700, '&:hover': { bgcolor: '#00C48C' } }} startIcon={<SaveIcon />}>Salvar</Button>
                  <Button variant="outlined" color="inherit" onClick={handleCancelEdit} sx={{ flex: 1 }} startIcon={<CloseIcon />}>Cancelar</Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Modal>
    </Container>
  );
}

export default function PeriodosPageWrapper(props) {
  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };
  return (
    <>
      <Header onLogout={handleLogout} />
      <ContextNavBar context="startfy" />
      <Periodos {...props} />
      <Footer />
    </>
  );
}
